import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import { isEmail } from 'validator';
import {Map} from "immutable";

// Components
import StatusSelector from "../../../components/common/StatusSelector";

// Actions
import { getUser, updateUser, changeUserStatus, cleanUsers } from "../../../actions/users";

class UserDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'view',
            name: '',
            surname: '',
            email: '',
            validName: true,
            validEmail: true,
            canSubmit: false,
        };
    }

    componentDidMount() {
        this.props.getUser(this.props.match.params.userId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user) {
            this.setUserState();
        }
    }

    componentWillUnmount() {
        this.props.cleanUsers();
    }

    setUserState = () => {
        this.setState({
            mode: 'view',
            name: this.props.user.get('name') || '',
            surname: this.props.user.get('surname') || '',
            email: this.props.user.get('email') || '',
            validName: true,
            validEmail: true,
            canSubmit: false
        })
    };

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue,
            ...(inputName === 'name') ? { validName: inputValue !== '' } : {},
            ...(inputName === 'email') ? { validEmail: isEmail(inputValue) } : {}
        }, () => this.setState({ canSubmit: this.state.validName && this.state.validEmail }));
    };

    render() {
        let statusColor = '', statusText = '';

        switch (this.props.user.get('status')) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/usuarios">Usuarios</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`${this.props.user.get('name')} ${this.props.user.get('surname') || ''}`}</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        {this.state.mode === 'view'
                            ? <div className="title-action">
                                <button className="btn btn-custom" onClick={() => this.setState({ mode: 'edit' })}>Editar</button>
                            </div>
                            : <div className="title-action">
                                <button className="btn btn-cancel" onClick={() => this.setUserState()}>Cancelar</button>
                                <button
                                    className="btn btn-custom"
                                    onClick={() => {
                                        this.setState({ mode: 'view' }, () => this.props.updateUser({
                                            _id: this.props.match.params.userId,
                                            name: this.state.name,
                                            surname: this.state.surname,
                                            email: this.state.email
                                        }))
                                    }}
                                    disabled={!this.state.canSubmit}
                                >Guardar
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.name}
                                                    disabled={this.state.mode === 'view'}
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Apellidos</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.surname}
                                                    disabled={this.state.mode === 'view'}
                                                    onChange={ (event) => this.onChangeInput('surname', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        { this.props.user.get('status') !== ''
                                            ? <div className="col-3 ml-auto">
                                                <label>Estado</label>
                                                { this.state.mode === 'view'
                                                    ? <div className="row">
                                                        <div className="col-6">
                                                            <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                                        </div>
                                                        <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                            <StatusSelector
                                                                statusObject={this.props.user}
                                                                statusOptions={['active', 'inactive']}
                                                                changeStatus={this.props.changeUserStatus}
                                                            />
                                                        </div>
                                                    </div>
                                                    : <div className="row">
                                                        <div className="col-6">
                                                            <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            : null
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Email *</label>
                                                <input
                                                    className="form-control"
                                                    type="email"
                                                    value={this.state.email}
                                                    disabled={this.state.mode === 'view'}
                                                    onChange={ (event) => this.onChangeInput('email', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const usersReducer = state.users;

    // User
    const user = usersReducer.get('payload') || Map({});

    return {
        user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (userId) => dispatch(getUser(userId)),
        updateUser: (user) => dispatch(updateUser(user)),
        changeUserStatus: (userId, status) => dispatch(changeUserStatus(userId, status)),
        cleanUsers: () => dispatch(cleanUsers())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/containers/configuration/users/UserDetail.js